import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaGlobe } from "react-icons/fa";
import LanguageModal from "../LanguageModal";

export default function FloatingButton() {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <div className="floating-buttons">
                <a
                    href="https://wa.me/919766833510" // change this to your WhatsApp number
                    target="_blank"
                    rel="noopener noreferrer"
                    className="floating-btn mail-btn"
                    aria-label="Chat on WhatsApp"
                >
                    <FaWhatsapp />
                </a>

                <a
                    href="tel:+91-9766833510"
                    className="floating-btn call-btn"
                    title="Call"
                >
                    <FaPhoneAlt />
                </a>

                <button
                    className="floating-btn lang-btn"
                    title="Change Language"
                    onClick={() => setShowModal(true)}
                >
                    <FaGlobe />
                </button>

                <LanguageModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            </div>
        </>
    );
}
